module.exports = __webpack_public_path__ + "static/media/spinner.792777f0.gif";